import React, { useState, useCallback } from "react";

import swal from "sweetalert";
import { Form, FormGroup, Button, FormField, Input } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api, producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock } from "./styles";

const CloseToExpiring = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [loading, setLoading] = useState(false);
  const [relatorioExcel, setRelatorioExcel] = useState(false);

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorioExcel(false);

    const errorController = { error: false };

    await producaov2
      .post("/admin/reports/close-to-expiring", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {
        setRelatorioExcel(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio de cursos prestes a expirar entre ${dataInicio} e ${dataFinal}`,
        });

        api.post("system_logs", { acao });
      })
      .catch((error) => {
        errorController.error = true;

        if (!error.response) {
          return;
        }

        if (error?.response?.status === 404) {
          return swal(
            `Ocorreu um erro ao gerar o relatório`,
            `Entre em contato com o time de TI`,
            "error",
          );
        }

        swal(
          `Algo deu errado na geração do relatório em Excel`,
          `Entre em contato com o time de TI`,
          "error",
        );
      });

    setLoading(false);

    if (!errorController.error) {
      swal("Confirmado!", "Relatório gerado com sucesso", "success");
    }
  }, [dataInicio, dataFinal]);

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Header>Relatório de Pessoas com Cursos Próximos do Vencimento</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>
            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              <>
                {relatorioExcel && (
                  <Button
                    style={{ minWidth: "80px" }}
                    onClick={() => window.open(relatorioExcel, "_blank")}
                    color="green"
                  >
                    Baixar Relatório Excel
                  </Button>
                )}
              </>
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default CloseToExpiring;
